import { useEffect, useState } from "react";
import DashLayout from "@/layouts/DashLayout";
import RoleProtectedPage from "@/layouts/RoleProtectedPage";
import Spinner from "@/components/Spinner";
import { useAppSelector } from "@/redux/features/hooks";
import { Roles } from "@/redux/services/user/user.type";
import KdsBoard from "@/components/pos/kds/KdsBoard";

const TOPBAR_HIDDEN_KEY = "kitchen.topBarHidden";

const KitchenPage = () => {
  const restaurant = useAppSelector((state) => state.user.currentRestaurant);
  const [hideTopBar, setHideTopBar] = useState<boolean>(
    () => localStorage.getItem(TOPBAR_HIDDEN_KEY) === "true",
  );

  useEffect(() => {
    localStorage.setItem(TOPBAR_HIDDEN_KEY, String(hideTopBar));
  }, [hideTopBar]);

  return (
    <DashLayout hideTopBar={hideTopBar}>
      <RoleProtectedPage allowedRoles={[Roles.manager, Roles.kitchen]}>
        {restaurant ? (
          <KdsBoard
            restaurantId={restaurant.id}
            hideTopBar={hideTopBar}
            onToggleTopBar={() => setHideTopBar((v) => !v)}
          />
        ) : (
          <div className="flex items-center justify-center py-12">
            <Spinner />
          </div>
        )}
      </RoleProtectedPage>
    </DashLayout>
  );
};

export default KitchenPage;
